import type { ExtensionField } from '../types'

export const etestingFields: ExtensionField[] = [
  {
    name: 'client_log',
    config: 'etesting.client_log',
    label: 'Identifiant client',
    type: 'text',
    level: 'instance'
  },
  {
    name: 'client_pas',
    config: 'etesting.client_pas',
    label: 'Mot de passe client',
    type: 'password',
    level: 'instance'
  },
  {
    name: 'filiale_id',
    config: 'etesting.filiale_id',
    label: 'Identifiant de filiale',
    type: 'text',
    level: 'agency'
  }
]
